
import AbstractAsset from '@structure/Resources/AbstractAsset';

export default {
  props: {
    resource: {
      required: true,
      type: AbstractAsset,
    },
  },

  computed: {
    type() {
      return this.resource.type().replace(/-zipped/i, '');
    },
  },
};
